
exports.ById = {
  1: { Id: 1, Name: 'Unit Price', Value: { displayFormat: 1, roundingValue: 2 } },
  2: { Id: 2, Name: 'COGS (related)', Value: { displayFormat: 1, roundingValue: 2 } },
  3: { Id: 3, Name: 'COGS (unrelated)', Value: { displayFormat: 1, roundingValue: 2 } },
  4: { Id: 4, Name: 'Resale Price', Value: { displayFormat: 1, roundingValue: 2 } },
  5: { Id: 5, Name: 'Sales Price', Value: { displayFormat: 1, roundingValue: 2 } },
  6: { Id: 6, Name: 'Royalty', Value: { displayFormat: 0, roundingValue: 2 } },
  7: { Id: 7, Name: 'Interest', Value: { displayFormat: 0, roundingValue: 2 } },
  8: { Id: 8, Name: 'Service', Value: { displayFormat: 0, roundingValue: 2 } },
  9: { Id: 9, Name: 'Gross Profit Markup', Value: { displayFormat: 0, roundingValue: 2 } },
  10: { Id: 10, Name: 'Gross Profit Margin', Value: { displayFormat: 0, roundingValue: 2 } },
};

exports.ByName = {
  'Unit Price': { Id: 1, Name: 'Unit Price', Value: { displayFormat: 1, roundingValue: 2 } },
  'COGS (related)': { Id: 2, Name: 'COGS (related)', Value: { displayFormat: 1, roundingValue: 2 } },
  'COGS (unrelated)': { Id: 3, Name: 'COGS (unrelated)', Value: { displayFormat: 1, roundingValue: 2 } },
  'Resale Price': { Id: 4, Name: 'Resale Price', Value: { displayFormat: 1, roundingValue: 2 } },
  'Sales Price': { Id: 5, Name: 'Sales Price', Value: { displayFormat: 1, roundingValue: 2 } },
  'Royalty': { Id: 6, Name: 'Royalty', Value: { displayFormat: 0, roundingValue: 2 } },
  'Interest': { Id: 7, Name: 'Interest', Value: { displayFormat: 0, roundingValue: 2 } },
  'Service': { Id: 8, Name: 'Service', Value: { displayFormat: 0, roundingValue: 2 } },
  'Gross Profit Markup': { Id: 9, Name: 'Gross Profit Markup', Value: { displayFormat: 0, roundingValue: 2 } },
  'Gross Profit Margin': { Id: 10, Name: 'Gross Profit Margin', Value: { displayFormat: 0, roundingValue: 2 } },
};